import 'ag-grid-enterprise';
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import {Amplify} from 'aws-amplify'
import '@aws-amplify/ui-react/styles.css';
import {  Authenticator, useTheme, View, Image, Flex, Heading, Text} from '@aws-amplify/ui-react';
import { useState, useEffect } from 'react';
import {  Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { FaDollarSign, FaFileInvoiceDollar, FaMoneyCheckAlt, FaPercent, FaTable, FaUserEdit,FaIdCardAlt, FaLandmark, FaCloud, FaCloudUploadAlt, FaTools, FaWpforms, FaListAlt, FaCar, FaBars, FaTachometerAlt, FaHome, FaUser, FaIdCard, FaUsers, FaComment, FaFileSignature, FaCogs, FaShieldAlt, FaBan } from 'react-icons/fa';
import { MdToll } from 'react-icons/md';
import { SidebarHeader, ProSidebar, Menu, MenuItem, SubMenu, SidebarFooter } from 'react-pro-sidebar';
import './styles/override-custome-pro-sidebar.scss';
import awsExports from "./aws-exports";
import AuthenticatedApp from "./components/AuthenticatedApp";
import Loadingmini from "./components/loadingmini";
import Fleetselector from "./components/fleetselector";
import { fleetQueryAction, recalledFleets, rememberFleets } from "./withFleets";
Amplify.configure(awsExports);
ModuleRegistry.registerModules([AllEnterpriseModule]);


const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          alt="Ago logo"
          src="https://ago-misc-public-photos.s3.us-east-2.amazonaws.com/ago_logov62_267.png"
        />
      </View>
    );
  },
}

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarCollapsed, updateSidebarCollapsed] = useState(true);
  const [selectedFleets, updateSelectedFleet] = useState([]);
  const personalInsuranceReviewLabel = 'Personal Insurance Review';
  const reservationCancelCloseReviewLabel = 'Cancel / Close Review';
  const fleetQuery =
    selectedFleets.length > 0
      ? `?fleets=${selectedFleets.join(",")}`
      : "";

  useEffect(() => {
    const action = fleetQueryAction({
      pathname: location.pathname,
      search: location.search,
      selectedFleets,
      recalled: recalledFleets(),
    });
    if (action.remember) rememberFleets(action.remember);
    if (action.selected) {
      updateSelectedFleet((prev) =>
        prev.join(",") === action.selected.join(",") ? prev : action.selected
      );
    }
    if (action.search !== null) {
      const nextSearch = action.search ? `?${action.search}` : "";
      if (nextSearch !== location.search) {
        navigate(`${location.pathname}${nextSearch}`, { replace: true });
      }
    }
  }, [location.search, location.pathname, selectedFleets, navigate]);

  function toggleSidebarCollapsed()
  {
    if(sidebarCollapsed===true)
    {
      updateSidebarCollapsed(false);
    } else {
      updateSidebarCollapsed(true);
    }
  }
  function openSidebarCollapsed()
  {
    if(sidebarCollapsed===true)
    {
      updateSidebarCollapsed(false);
    }
  }
  const { tokens } = useTheme();

  var SupportSubMenu = 
  <View>
    <MenuItem icon={<FaHome />}>
      <Link
        to={`/?fleets=${selectedFleets.join(",")}`}
      >
        Alerts
      </Link>
    </MenuItem>
    <MenuItem icon={<FaListAlt />}>
      <Link
        to={`/reservations?fleets=${selectedFleets.join(",")}`}
      >
        Reservations
      </Link>
    </MenuItem>
    <MenuItem icon={<FaCar />}>
      <Link
        to={`/assets?fleets=${selectedFleets.join(",")}`}
      >
        Assets
      </Link>
    </MenuItem>
    <MenuItem icon={<FaUsers />}>
      <Link
        to={`/renters?fleets=${selectedFleets.join(",")}`}
      >
        Renters
      </Link>
    </MenuItem>
    <MenuItem icon={<FaUserEdit />}>
      <Link to="/combine-accounts">
        Combine accounts
      </Link>
    </MenuItem>
    <MenuItem icon={<FaShieldAlt />}>
      <Link to={`/personal-insurance-review${fleetQuery}`}>
        {personalInsuranceReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaBan />}>
      <Link to={`/reservation-cancel-close-review${fleetQuery}`}>
        {reservationCancelCloseReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaFileSignature />}>
      <Link to={`/insurance-programs?fleets=${selectedFleets.join(",")}`}>
        Policy Management
      </Link>
    </MenuItem>
    <SubMenu icon={<MdToll />} title='Incidentals' onClick={() => openSidebarCollapsed()}>
      <MenuItem>
        <Link to={`/incidentals?tab=attribution&fleets=${selectedFleets.join(",")}`}>
          Needs attribution
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/incidentals?tab=collection&fleets=${selectedFleets.join(",")}`}>
          Collection
        </Link>
      </MenuItem>
    </SubMenu>
    <MenuItem icon={<FaTable />}>
      <Link
        to={`/fleetwidesummary?fleets=${selectedFleets.join(",")}`}
      >
        Fleetwide Summary
      </Link>
    </MenuItem>
    <MenuItem icon={<FaDollarSign />}>
      <Link
        to={`/pricing?fleets=${selectedFleets.join(",")}`}
      >
        Pricing
      </Link>
    </MenuItem>
    <MenuItem icon={<FaPercent />}>
      <Link
        to={`/taxes?fleets=${selectedFleets.join(",")}`}
      >
        Taxes
      </Link>
    </MenuItem>
    <SubMenu icon={<FaCogs />} title='Advanced' onClick={() => openSidebarCollapsed()}>
      <MenuItem icon={<FaWpforms />}>
        <Link
          to={`/dispute?fleets=${selectedFleets.join(",")}`}
        >
          Payment Dispute
        </Link>
      </MenuItem>
    </SubMenu>
  </View>

  var FleetSubMenu = 
  <View>
    <MenuItem icon={<FaHome />}>
      <Link
        to={`/?fleets=${selectedFleets.join(",")}`}
      >
        Alerts
      </Link>
    </MenuItem>
    <MenuItem icon={<FaListAlt />}>
      <Link
        to={`/reservations?fleets=${selectedFleets.join(",")}`}
      >
        Reservations
      </Link>
    </MenuItem>
    <MenuItem icon={<FaCar />}>
      <Link
        to={`/assets?fleets=${selectedFleets.join(",")}`}
      >
        Assets
      </Link>
    </MenuItem>
    <MenuItem icon={<FaUsers />}>
      <Link
        to={`/renters?fleets=${selectedFleets.join(",")}`}
      >
        Renters
      </Link>
    </MenuItem>
    <MenuItem icon={<FaShieldAlt />}>
      <Link to={`/personal-insurance-review${fleetQuery}`}>
        {personalInsuranceReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaBan />}>
      <Link to={`/reservation-cancel-close-review${fleetQuery}`}>
        {reservationCancelCloseReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaFileSignature />}>
      <Link to={`/insurance-programs?fleets=${selectedFleets.join(",")}`}>
        Policy Management
      </Link>
    </MenuItem>
    <SubMenu icon={<MdToll />} title='Incidentals' onClick={() => openSidebarCollapsed()}>
      <MenuItem>
        <Link to={`/incidentals?tab=attribution&fleets=${selectedFleets.join(",")}`}>
          Needs attribution
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/incidentals?tab=collection&fleets=${selectedFleets.join(",")}`}>
          Collection
        </Link>
      </MenuItem>
    </SubMenu>
    <MenuItem icon={<FaTable />}>
      <Link
        to={`/fleetwidesummary?fleets=${selectedFleets.join(",")}`}
      >
        Fleetwide Summary
      </Link>
    </MenuItem>
    <MenuItem icon={<FaMoneyCheckAlt />}>
      <Link
        to={`/billinghistory?fleets=${selectedFleets.join(",")}`}
      >
        Billing History
      </Link>
    </MenuItem>
    <MenuItem icon={<FaDollarSign />}>
      <Link
        to={`/pricing?fleets=${selectedFleets.join(",")}`}
      >
        Pricing
      </Link>
    </MenuItem>
    <MenuItem icon={<FaPercent />}>
      <Link
        to={`/taxes?fleets=${selectedFleets.join(",")}`}
      >
        Taxes
      </Link>
    </MenuItem>
    <SubMenu icon={<FaCogs />} title='Advanced' onClick={() => openSidebarCollapsed()}>
      <MenuItem icon={<FaWpforms />}>
        <Link
          to={`/dispute?fleets=${selectedFleets.join(",")}`}
        >
          Payment Dispute
        </Link>
      </MenuItem>
      <MenuItem icon={<FaCloudUploadAlt />}>
        <Link
          to={`/bulkuploads?fleets=${selectedFleets.join(",")}`}
        >
          Uploads
        </Link>
      </MenuItem>
    </SubMenu>
  </View>
/*

      <MenuItem icon={<FaFileInvoiceDollar />}>
        <Link
          to={`/vehiclesutilization?fleets=${selectedFleets.join(",")}`}
        >
          Fleet Utilization
        </Link>
      </MenuItem>
*/


  var AdminSubMenu = 
  <View>
    <MenuItem icon={<FaHome />}>
      <Link
        to={`/?fleets=${selectedFleets.join(",")}`}
      >
        Alerts
      </Link>
    </MenuItem>
    <MenuItem icon={<FaListAlt />}>
      <Link
        to={`/reservations?fleets=${selectedFleets.join(",")}`}
      >
        Reservations
      </Link>
    </MenuItem>
    <MenuItem icon={<FaCar />}>
      <Link
        to={`/assets?fleets=${selectedFleets.join(",")}`}
      >
        Assets
      </Link>
    </MenuItem>
    <MenuItem icon={<FaUsers />}>
      <Link
        to={`/renters?fleets=${selectedFleets.join(",")}`}
      >
        Renters
      </Link>
    </MenuItem>
    <MenuItem icon={<FaShieldAlt />}>
      <Link to={`/personal-insurance-review${fleetQuery}`}>
        {personalInsuranceReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaBan />}>
      <Link to={`/reservation-cancel-close-review${fleetQuery}`}>
        {reservationCancelCloseReviewLabel}
      </Link>
    </MenuItem>
    <MenuItem icon={<FaFileSignature />}>
      <Link to={`/insurance-programs?fleets=${selectedFleets.join(",")}`}>
        Policy Management
      </Link>
    </MenuItem>
    <SubMenu icon={<MdToll />} title='Incidentals' onClick={() => openSidebarCollapsed()}>
      <MenuItem>
        <Link to={`/incidentals?tab=attribution&fleets=${selectedFleets.join(",")}`}>
          Needs attribution
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/incidentals?tab=collection&fleets=${selectedFleets.join(",")}`}>
          Collection
        </Link>
      </MenuItem>
    </SubMenu>
    <MenuItem icon={<FaTable />}>
      <Link
        to={`/fleetwidesummary?fleets=${selectedFleets.join(",")}`}
      >
        Fleetwide Summary
      </Link>
    </MenuItem>
    <MenuItem icon={<FaMoneyCheckAlt />}>
      <Link
        to={`/billinghistory?fleets=${selectedFleets.join(",")}`}
      >
        Billing History
      </Link>
    </MenuItem>
    <MenuItem icon={<FaDollarSign />}>
      <Link
        to={`/pricing?fleets=${selectedFleets.join(",")}`}
      >
        Pricing
      </Link>
    </MenuItem>
    <MenuItem icon={<FaPercent />}>
      <Link
        to={`/taxes?fleets=${selectedFleets.join(",")}`}
      >
        Taxes
      </Link>
    </MenuItem>
    <SubMenu icon={<FaCogs />} title='Advanced' onClick={() => openSidebarCollapsed()}>
      <MenuItem icon={<FaWpforms />}>
        <Link
          to={`/dispute?fleets=${selectedFleets.join(",")}`}
        >
          Payment Dispute
        </Link>
      </MenuItem>
      <MenuItem icon={<FaFileInvoiceDollar />}>
        <Link
          to={`/vehiclesutilization?fleets=${selectedFleets.join(",")}`}
        >
          Fleet Utilization
        </Link>
      </MenuItem>
      <MenuItem icon={<FaCloudUploadAlt />}>
        <Link
          to={`/bulkuploads?fleets=${selectedFleets.join(",")}`}
        >
          Uploads
        </Link>
      </MenuItem>
      <MenuItem icon={<FaUsers />}>
        <Link to="/admin/users">User Management</Link>
      </MenuItem>
      <MenuItem icon={<FaUserEdit />}>
        <Link to="/combine-accounts">Combine accounts</Link>
      </MenuItem>
      <MenuItem icon={<FaIdCardAlt />}>
        <Link to="/admin/checks">Background Checks</Link>
      </MenuItem>
      <MenuItem icon={<FaShieldAlt />}>
        <Link to="/admin/endorsement-review">Endorsement Review</Link>
      </MenuItem>
      <MenuItem icon={<FaListAlt />}>
        <Link to="/admin/gig-accounts">Gig Account Status</Link>
      </MenuItem>
      <MenuItem icon={<FaListAlt />}>
        <Link to="/admin/gig-disconnect">Gig Disconnect Queue</Link>
      </MenuItem>
      <MenuItem icon={<FaTools />}>
        <Link to="/admin/systems">Systems Dashboard</Link>
      </MenuItem>
    </SubMenu>
  </View>

  var DriverSubMenu = 
  <View>
    <MenuItem icon={<FaHome />}><Link to="/dashboard">Dashboard</Link></MenuItem>
    <MenuItem icon={<FaTachometerAlt />}><Link to="/recenttrips">Recent Trips</Link></MenuItem>
    <MenuItem icon={<FaListAlt />}><Link to="/gigintegrations">Gig Integrations</Link></MenuItem>
  </View>

  var DriverAccountMenu =
  <View>
    <MenuItem icon={<FaLandmark />}><Link to="/fleetassignment">Join a Fleet</Link></MenuItem>
    <MenuItem icon={<FaIdCard />}><Link to="/uploadlicense">Update License</Link></MenuItem>
    <MenuItem icon={<FaIdCardAlt />}><Link to="/uploadlicenseback">Update License Back</Link></MenuItem>
  </View>

  var DriverAgreementsMenu =
  <SubMenu icon={<FaFileSignature />} title='Agreements'>
    <View>
      <MenuItem icon={<FaFileSignature />}><Link to="/agreements/fcra">FCRA Rights</Link></MenuItem>
      <MenuItem icon={<FaFileSignature />}><Link to="/agreements/disclosure">Disclosure</Link></MenuItem>
      <MenuItem icon={<FaFileSignature />}><Link to="/agreements/authorization">Authorization</Link></MenuItem>
      <MenuItem icon={<FaFileSignature />}><Link to="/esign">E-Sign</Link></MenuItem>
      <MenuItem icon={<FaFileSignature />}><Link to="/terms">Terms</Link></MenuItem>
    </View>
  </SubMenu>

  var InsuranceSubMenu = 
  <View>
    <MenuItem icon={<FaCar />}>
      <Link
        to={`/assets?fleets=${selectedFleets.join(",")}`}
      >
        Assets
      </Link>
    </MenuItem>
    <MenuItem icon={<FaUsers />}>
      <Link
        to={`/renters?fleets=${selectedFleets.join(",")}`}
      >
        Renters
      </Link>
    </MenuItem>
    <MenuItem icon={<FaFileSignature />}>
      <Link
        to={`/insuranceendorsements?fleets=${selectedFleets.join(",")}`}
      >
        Endorsements
      </Link>
    </MenuItem>
  </View>

  return (
      <Authenticator hideSignUp initialState="signIn" components={components}>
        {({ signOut, user }) => !user?.signInUserSession?.accessToken ? (
          <Loadingmini />
        ) : (
          <AuthenticatedApp user={user} signOut={signOut}>
            <Flex direction="row">
                <ProSidebar collapsed={sidebarCollapsed} collapsedWidth='80px'>
                  <SidebarHeader>
                    <View textAlign="center" padding={tokens.space.large}>
                      <Image
                        alt="Ago logo"
                        src="https://ago-misc-public-photos.s3.us-east-2.amazonaws.com/ago_logov62_267.png"
                        onClick={() => toggleSidebarCollapsed()}
                      />     
                      {sidebarCollapsed ? undefined : <Text style={{color:"#adadad", fontWeight:'bold', 'fontSize': 18, paddingTop: '7px'}}>Dual Telemetry</Text>}
                      <br/>
                      <Fleetselector 
                        selectedFleets={selectedFleets} 
                        updateParentSelectedFleet={updateSelectedFleet} 
                        sidebarCollapsed={sidebarCollapsed} 
                        openSidebarCollapsed={openSidebarCollapsed}
                      />
                    </View>
                  </SidebarHeader>
                  <Menu>
                      {user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? DriverSubMenu : 
                      user.signInUserSession.accessToken.payload["cognito:groups"][0] ==='admin' ? AdminSubMenu : 
                      user.signInUserSession.accessToken.payload["cognito:groups"][0] ==='fleet' ? FleetSubMenu : 
                      user.signInUserSession.accessToken.payload["cognito:groups"][0] ==='insurer' ? InsuranceSubMenu : 
                      user.signInUserSession.accessToken.payload["cognito:groups"][0] ==='support' ? SupportSubMenu : DriverSubMenu}
                      {user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? 
                      DriverAgreementsMenu
                      : undefined}

                    {/*user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? undefined : user.signInUserSession.accessToken.payload["cognito:groups"][0] === 'fleet' ? <SubMenu icon={<FaCloud />} title='Schedules' onClick={() => openSidebarCollapsed()}>
                      <View>
                        <MenuItem icon={<FaListAlt />}><Link to="/fleetschedule">Fleet Schedule</Link></MenuItem>
                        <MenuItem icon={<FaCloudUploadAlt />}><Link to="/uploadschedule">Upload Schedule</Link></MenuItem>
                        <MenuItem icon={<FaCloud />}><Link to="/scheduleuploads">Schedule Uploads</Link></MenuItem>
                      </View>
                    </SubMenu>
                    : undefined*/}


                    <SubMenu icon={<FaUser />} title='Account' onClick={() => openSidebarCollapsed()}>
                        {user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? 
                          <MenuItem icon={<FaUserEdit />}><Link to="/accountinfo">Edit Account Info</Link></MenuItem>
                        : <MenuItem icon={<FaUserEdit />}><Link to="/accountinfoalt">Edit Account Info</Link></MenuItem>}
                        {user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? 
                          DriverAccountMenu
                        : undefined}
                        {user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? 
                          <MenuItem icon={<FaFileSignature />}><Link to="/terms">Terms</Link></MenuItem>
                        : undefined}
                        <br/>
                        <MenuItem>
                          <p>{user.signInUserSession.idToken.payload.email}<br/>{user.attributes['phone_number']}<br/>{user.signInUserSession.accessToken.payload["cognito:groups"] === undefined ? "driver" : user.signInUserSession.accessToken.payload["cognito:groups"][0]}</p>
                        </MenuItem>
                        <MenuItem> 
                          <button onClick={signOut} style={{paddingTop:5, paddingBottom:5, paddingLeft:30, paddingRight:30, backgroundColor:"#092F50",color:"#fff", borderRadius:5}}>Sign out</button>
                        </MenuItem>
                        <br/>
                    </SubMenu>
                    <br/>
                    <br/>
                    <br/>
                    <SidebarFooter> 
                      <MenuItem icon={<FaBars />} onClick={() => toggleSidebarCollapsed()} >Close Drawer</MenuItem>
                    </SidebarFooter>
                  </Menu>
                </ProSidebar>
                <Outlet />
            </Flex>
          </AuthenticatedApp>
        )}
      </Authenticator>
  );
}

export default App